import { InjectionToken } from "@angular/core";

export const LIST_CONTROLS_STATE_PROP = new InjectionToken<string>("LIST_CONTROLS_STATE_PROP");
export const listControlsStatePropProvider = {
    provide: LIST_CONTROLS_STATE_PROP,
    useValue: "listControls",
};
